export enum MenuComponentControl {
  CompactDropdown = 'compact-dropdown',
  Dropdown = 'dropdown',
  Radio = 'radio',
}
